import BackgroundGlowing from '../../components/main/background-glowing';
import TMLabel from '../../components/tm-label';
import LeftSide from './left-side/left-side';
import RightSide from './right-side/right-side';
import { GlowingCss } from './right-side/styles';
import { MainBlock } from './styles';

function MasterBoardPage() {
  return (
    <MainBlock>
      <BackgroundGlowing className="tm-logo" {...backgroundProps}>
        <TMLabel fontSize={320} style={{ height: 416 }} className={'flex-center'} />
      </BackgroundGlowing>
      <LeftSide className="left-side" />
      <RightSide className="right-side" />
    </MainBlock>
  );
}

export default MasterBoardPage;

const backgroundProps = {
  style: { zIndex: -1 },
  color: '#511D7E80',
  size: 384,
  blur: 100,
  glowingProps: {
    css: GlowingCss('#511D7E80', '#511D7E'),
  },
};
